module.exports = __webpack_public_path__ + "static/media/26UNRWA26.d3bbac86.jpg";